/** Indian states / UTs with major cities for delivery partner registration. */

export const OTHER_LOCATION = "__other__" as const;

export type IndiaState = {
  name: string;
  cities: string[];
};

export const INDIA_STATES: IndiaState[] = [
  {
    name: "Andaman and Nicobar Islands",
    cities: ["Port Blair", "Diglipur", "Mayabunder", "Rangat", "Car Nicobar", "Campbell Bay"],
  },
  {
    name: "Andhra Pradesh",
    cities: [
      "Visakhapatnam",
      "Vijayawada",
      "Guntur",
      "Nellore",
      "Kurnool",
      "Rajahmundry",
      "Tirupati",
      "Kakinada",
      "Kadapa",
      "Anantapur",
      "Eluru",
      "Ongole",
      "Chittoor",
      "Machilipatnam",
      "Tenali",
      "Proddatur",
      "Hindupur",
      "Bhimavaram",
      "Madanapalle",
      "Guntakal",
      "Dharmavaram",
      "Gudivada",
      "Narasaraopet",
      "Tadepalligudem",
      "Amaravati",
      "Srikakulam",
      "Vizianagaram",
    ],
  },
  {
    name: "Arunachal Pradesh",
    cities: [
      "Itanagar",
      "Naharlagun",
      "Pasighat",
      "Tawang",
      "Ziro",
      "Bomdila",
      "Tezu",
      "Roing",
      "Along",
      "Changlang",
      "Khonsa",
      "Daporijo",
    ],
  },
  {
    name: "Assam",
    cities: [
      "Guwahati",
      "Silchar",
      "Dibrugarh",
      "Jorhat",
      "Nagaon",
      "Tinsukia",
      "Tezpur",
      "Bongaigaon",
      "Dhubri",
      "Diphu",
      "North Lakhimpur",
      "Karimganj",
      "Goalpara",
      "Barpeta",
      "Sivasagar",
      "Golaghat",
      "Haflong",
      "Kokrajhar",
      "Nalbari",
      "Mangaldoi",
    ],
  },
  {
    name: "Bihar",
    cities: [
      "Patna",
      "Gaya",
      "Bhagalpur",
      "Muzaffarpur",
      "Purnia",
      "Darbhanga",
      "Bihar Sharif",
      "Arrah",
      "Begusarai",
      "Katihar",
      "Munger",
      "Chhapra",
      "Danapur",
      "Saharsa",
      "Sasaram",
      "Hajipur",
      "Dehri",
      "Siwan",
      "Motihari",
      "Nawada",
      "Bagha",
      "Buxar",
      "Kishanganj",
      "Sitamarhi",
      "Jamalpur",
      "Jehanabad",
      "Aurangabad",
      "Lakhisarai",
      "Sheikhpura",
      "Madhubani",
      "Samastipur",
      "Bettiah",
      "Gopalganj",
      "Forbesganj",
      "Mokama",
      "Jamalpur",
      "Phulwari Sharif",
      "Masaurhi",
      "Khagaul",
    ],
  },
  {
    name: "Chandigarh",
    cities: ["Chandigarh", "Manimajra", "Sector 17", "Industrial Area"],
  },
  {
    name: "Chhattisgarh",
    cities: [
      "Raipur",
      "Bhilai",
      "Bilaspur",
      "Korba",
      "Durg",
      "Rajnandgaon",
      "Raigarh",
      "Jagdalpur",
      "Ambikapur",
      "Dhamtari",
      "Chirmiri",
      "Mahasamund",
      "Kanker",
      "Kawardha",
      "Dongargarh",
      "Bhatapara",
      "Janjgir",
      "Bemetara",
    ],
  },
  {
    name: "Dadra and Nagar Haveli and Daman and Diu",
    cities: ["Silvassa", "Daman", "Diu", "Amli", "Naroli", "Khanvel"],
  },
  {
    name: "Delhi",
    cities: [
      "New Delhi",
      "Central Delhi",
      "North Delhi",
      "South Delhi",
      "East Delhi",
      "West Delhi",
      "North East Delhi",
      "North West Delhi",
      "South East Delhi",
      "South West Delhi",
      "Shahdara",
      "Dwarka",
      "Rohini",
      "Saket",
      "Karol Bagh",
      "Connaught Place",
      "Laxmi Nagar",
      "Janakpuri",
      "Pitampura",
      "Mayur Vihar",
    ],
  },
  {
    name: "Goa",
    cities: [
      "Panaji",
      "Margao",
      "Vasco da Gama",
      "Mapusa",
      "Ponda",
      "Bicholim",
      "Curchorem",
      "Canacona",
      "Valpoi",
      "Sanquelim",
      "Quepem",
      "Pernem",
    ],
  },
  {
    name: "Gujarat",
    cities: [
      "Ahmedabad",
      "Surat",
      "Vadodara",
      "Rajkot",
      "Bhavnagar",
      "Jamnagar",
      "Junagadh",
      "Gandhinagar",
      "Anand",
      "Nadiad",
      "Morbi",
      "Mehsana",
      "Bhuj",
      "Porbandar",
      "Palanpur",
      "Valsad",
      "Vapi",
      "Bharuch",
      "Navsari",
      "Surendranagar",
      "Gandhidham",
      "Veraval",
      "Godhra",
      "Patan",
      "Kalol",
      "Botad",
      "Amreli",
      "Dahod",
      "Deesa",
      "Jetpur",
    ],
  },
  {
    name: "Haryana",
    cities: [
      "Gurugram",
      "Faridabad",
      "Panipat",
      "Ambala",
      "Yamunanagar",
      "Rohtak",
      "Hisar",
      "Karnal",
      "Sonipat",
      "Panchkula",
      "Bhiwani",
      "Sirsa",
      "Bahadurgarh",
      "Jind",
      "Thanesar",
      "Kaithal",
      "Rewari",
      "Palwal",
      "Narnaul",
      "Fatehabad",
      "Hansi",
      "Mahendragarh",
      "Gohana",
      "Narwana",
      "Tohana",
    ],
  },
  {
    name: "Himachal Pradesh",
    cities: [
      "Shimla",
      "Dharamshala",
      "Solan",
      "Mandi",
      "Palampur",
      "Kullu",
      "Manali",
      "Bilaspur",
      "Chamba",
      "Una",
      "Hamirpur",
      "Nahan",
      "Baddi",
      "Kangra",
      "Sundernagar",
      "Paonta Sahib",
      "Keylong",
      "Reckong Peo",
    ],
  },
  {
    name: "Jammu and Kashmir",
    cities: [
      "Srinagar",
      "Jammu",
      "Anantnag",
      "Baramulla",
      "Sopore",
      "Kathua",
      "Udhampur",
      "Rajouri",
      "Poonch",
      "Pulwama",
      "Kupwara",
      "Budgam",
      "Ganderbal",
      "Bandipora",
      "Samba",
      "Reasi",
      "Kishtwar",
      "Doda",
    ],
  },
  {
    name: "Jharkhand",
    cities: [
      "Ranchi",
      "Jamshedpur",
      "Dhanbad",
      "Bokaro",
      "Deoghar",
      "Hazaribagh",
      "Giridih",
      "Ramgarh",
      "Phusro",
      "Medininagar",
      "Chaibasa",
      "Dumka",
      "Godda",
      "Sahibganj",
      "Pakur",
      "Jhumri Telaiya",
      "Chirkunda",
      "Gumla",
      "Lohardaga",
      "Simdega",
    ],
  },
  {
    name: "Karnataka",
    cities: [
      "Bengaluru",
      "Mysuru",
      "Mangaluru",
      "Hubballi",
      "Belagavi",
      "Kalaburagi",
      "Davangere",
      "Ballari",
      "Vijayapura",
      "Shivamogga",
      "Tumakuru",
      "Raichur",
      "Bidar",
      "Hospet",
      "Hassan",
      "Udupi",
      "Chitradurga",
      "Kolar",
      "Mandya",
      "Chikkamagaluru",
      "Gadag",
      "Bagalkot",
      "Robertsonpet",
      "Bhadravati",
      "Chikkaballapur",
      "Karwar",
      "Ranebennuru",
      "Gangavati",
      "Yadgir",
      "Dharwad",
    ],
  },
  {
    name: "Kerala",
    cities: [
      "Thiruvananthapuram",
      "Kochi",
      "Kozhikode",
      "Thrissur",
      "Kollam",
      "Alappuzha",
      "Kannur",
      "Kottayam",
      "Palakkad",
      "Malappuram",
      "Manjeri",
      "Thalassery",
      "Ponnani",
      "Vatakara",
      "Kanhangad",
      "Kasargod",
      "Pathanamthitta",
      "Idukki",
      "Kalpetta",
      "Punalur",
      "Neyyattinkara",
      "Kayamkulam",
      "Changanassery",
      "Tirur",
      "Perinthalmanna",
    ],
  },
  {
    name: "Ladakh",
    cities: ["Leh", "Kargil", "Nubra", "Diskit", "Drass", "Zanskar"],
  },
  {
    name: "Lakshadweep",
    cities: ["Kavaratti", "Agatti", "Amini", "Andrott", "Minicoy", "Kalpeni"],
  },
  {
    name: "Madhya Pradesh",
    cities: [
      "Bhopal",
      "Indore",
      "Jabalpur",
      "Gwalior",
      "Ujjain",
      "Sagar",
      "Dewas",
      "Satna",
      "Ratlam",
      "Rewa",
      "Murwara",
      "Singrauli",
      "Burhanpur",
      "Khandwa",
      "Bhind",
      "Chhindwara",
      "Guna",
      "Shivpuri",
      "Vidisha",
      "Chhatarpur",
      "Damoh",
      "Mandsaur",
      "Khargone",
      "Neemuch",
      "Pithampur",
      "Hoshangabad",
      "Itarsi",
      "Seoni",
      "Betul",
      "Morena",
    ],
  },
  {
    name: "Maharashtra",
    cities: [
      "Mumbai",
      "Pune",
      "Nagpur",
      "Thane",
      "Nashik",
      "Aurangabad",
      "Solapur",
      "Amravati",
      "Kolhapur",
      "Navi Mumbai",
      "Kalyan",
      "Vasai-Virar",
      "Sangli",
      "Malegaon",
      "Jalgaon",
      "Akola",
      "Latur",
      "Dhule",
      "Ahmednagar",
      "Chandrapur",
      "Parbhani",
      "Ichalkaranji",
      "Jalna",
      "Ambarnath",
      "Bhusawal",
      "Panvel",
      "Satara",
      "Beed",
      "Yavatmal",
      "Kamptee",
      "Gondia",
      "Barshi",
      "Achalpur",
      "Osmanabad",
      "Nanded",
      "Wardha",
      "Udgir",
      "Hinganghat",
    ],
  },
  {
    name: "Manipur",
    cities: [
      "Imphal",
      "Thoubal",
      "Bishnupur",
      "Churachandpur",
      "Ukhrul",
      "Senapati",
      "Kakching",
      "Moreh",
      "Jiribam",
      "Tamenglong",
      "Chandel",
    ],
  },
  {
    name: "Meghalaya",
    cities: [
      "Shillong",
      "Tura",
      "Jowai",
      "Nongstoin",
      "Williamnagar",
      "Baghmara",
      "Resubelpara",
      "Mairang",
      "Cherrapunji",
    ],
  },
  {
    name: "Mizoram",
    cities: [
      "Aizawl",
      "Lunglei",
      "Saiha",
      "Champhai",
      "Kolasib",
      "Serchhip",
      "Lawngtlai",
      "Mamit",
      "Khawzawl",
      "Hnahthial",
    ],
  },
  {
    name: "Nagaland",
    cities: [
      "Kohima",
      "Dimapur",
      "Mokokchung",
      "Tuensang",
      "Wokha",
      "Zunheboto",
      "Phek",
      "Mon",
      "Kiphire",
      "Longleng",
      "Peren",
    ],
  },
  {
    name: "Odisha",
    cities: [
      "Bhubaneswar",
      "Cuttack",
      "Rourkela",
      "Berhampur",
      "Sambalpur",
      "Puri",
      "Balasore",
      "Bhadrak",
      "Baripada",
      "Jharsuguda",
      "Jeypore",
      "Bargarh",
      "Angul",
      "Dhenkanal",
      "Kendujhar",
      "Rayagada",
      "Paradip",
      "Bhawanipatna",
      "Balangir",
      "Koraput",
      "Sunabeda",
      "Phulbani",
      "Kendrapara",
      "Jagatsinghpur",
    ],
  },
  {
    name: "Puducherry",
    cities: ["Puducherry", "Karaikal", "Mahe", "Yanam", "Oulgaret", "Villianur"],
  },
  {
    name: "Punjab",
    cities: [
      "Ludhiana",
      "Amritsar",
      "Jalandhar",
      "Patiala",
      "Bathinda",
      "Mohali",
      "Hoshiarpur",
      "Batala",
      "Pathankot",
      "Moga",
      "Abohar",
      "Malerkotla",
      "Khanna",
      "Phagwara",
      "Muktsar",
      "Barnala",
      "Rajpura",
      "Firozpur",
      "Kapurthala",
      "Zirakpur",
      "Gurdaspur",
      "Sangrur",
      "Faridkot",
      "Ropar",
      "Nawanshahr",
    ],
  },
  {
    name: "Rajasthan",
    cities: [
      "Jaipur",
      "Jodhpur",
      "Kota",
      "Bikaner",
      "Ajmer",
      "Udaipur",
      "Bhilwara",
      "Alwar",
      "Bharatpur",
      "Sikar",
      "Pali",
      "Sri Ganganagar",
      "Kishangarh",
      "Beawar",
      "Hanumangarh",
      "Dhaulpur",
      "Gangapur City",
      "Sawai Madhopur",
      "Churu",
      "Jhunjhunu",
      "Barmer",
      "Tonk",
      "Nagaur",
      "Banswara",
      "Bundi",
      "Chittorgarh",
      "Makrana",
      "Sujangarh",
      "Hindaun",
      "Balotra",
    ],
  },
  {
    name: "Sikkim",
    cities: ["Gangtok", "Namchi", "Gyalshing", "Mangan", "Rangpo", "Jorethang", "Singtam", "Pakyong"],
  },
  {
    name: "Tamil Nadu",
    cities: [
      "Chennai",
      "Coimbatore",
      "Madurai",
      "Tiruchirappalli",
      "Salem",
      "Tirunelveli",
      "Tiruppur",
      "Vellore",
      "Erode",
      "Thoothukudi",
      "Dindigul",
      "Thanjavur",
      "Ranipet",
      "Sivakasi",
      "Karur",
      "Udhagamandalam",
      "Hosur",
      "Nagercoil",
      "Kanchipuram",
      "Kumarapalayam",
      "Karaikudi",
      "Neyveli",
      "Cuddalore",
      "Kumbakonam",
      "Tiruvannamalai",
      "Pollachi",
      "Rajapalayam",
      "Gudiyatham",
      "Pudukkottai",
      "Vaniyambadi",
      "Ambur",
      "Nagapattinam",
    ],
  },
  {
    name: "Telangana",
    cities: [
      "Hyderabad",
      "Warangal",
      "Nizamabad",
      "Khammam",
      "Karimnagar",
      "Ramagundam",
      "Mahbubnagar",
      "Nalgonda",
      "Adilabad",
      "Suryapet",
      "Miryalaguda",
      "Siddipet",
      "Jagtial",
      "Mancherial",
      "Kodad",
      "Kothagudem",
      "Bodhan",
      "Sangareddy",
      "Metpally",
      "Zahirabad",
      "Medak",
      "Vikarabad",
      "Tandur",
      "Bhongir",
    ],
  },
  {
    name: "Tripura",
    cities: [
      "Agartala",
      "Udaipur",
      "Dharmanagar",
      "Kailasahar",
      "Belonia",
      "Khowai",
      "Ambassa",
      "Sabroom",
      "Teliamura",
      "Sonamura",
    ],
  },
  {
    name: "Uttar Pradesh",
    cities: [
      "Lucknow",
      "Kanpur",
      "Ghaziabad",
      "Agra",
      "Varanasi",
      "Meerut",
      "Prayagraj",
      "Bareilly",
      "Aligarh",
      "Moradabad",
      "Saharanpur",
      "Gorakhpur",
      "Noida",
      "Firozabad",
      "Jhansi",
      "Muzaffarnagar",
      "Mathura",
      "Ayodhya",
      "Rampur",
      "Shahjahanpur",
      "Farrukhabad",
      "Mau",
      "Hapur",
      "Etawah",
      "Mirzapur",
      "Bulandshahr",
      "Sambhal",
      "Amroha",
      "Hardoi",
      "Fatehpur",
      "Raebareli",
      "Orai",
      "Sitapur",
      "Bahraich",
      "Modinagar",
      "Unnao",
      "Jaunpur",
      "Lakhimpur",
      "Hathras",
      "Banda",
      "Pilibhit",
      "Barabanki",
      "Khurja",
      "Gonda",
      "Mainpuri",
      "Lalitpur",
      "Etah",
      "Deoria",
      "Basti",
      "Greater Noida",
    ],
  },
  {
    name: "Uttarakhand",
    cities: [
      "Dehradun",
      "Haridwar",
      "Roorkee",
      "Haldwani",
      "Rudrapur",
      "Kashipur",
      "Rishikesh",
      "Nainital",
      "Mussoorie",
      "Almora",
      "Pithoragarh",
      "Kotdwar",
      "Ramnagar",
      "Jaspur",
      "Kichha",
      "Sitarganj",
      "Bageshwar",
      "Champawat",
      "Tehri",
      "Srinagar Garhwal",
    ],
  },
  {
    name: "West Bengal",
    cities: [
      "Kolkata",
      "Howrah",
      "Durgapur",
      "Asansol",
      "Siliguri",
      "Bardhaman",
      "Malda",
      "Baharampur",
      "Habra",
      "Kharagpur",
      "Shantipur",
      "Dankuni",
      "Dhulian",
      "Ranaghat",
      "Haldia",
      "Raiganj",
      "Krishnanagar",
      "Nabadwip",
      "Medinipur",
      "Jalpaiguri",
      "Balurghat",
      "Basirhat",
      "Bankura",
      "Purulia",
      "Alipurduar",
      "Cooch Behar",
      "Darjeeling",
      "Kalimpong",
      "English Bazar",
      "Chandannagar",
    ],
  },
];

export const INDIA_STATE_NAMES = INDIA_STATES.map((s) => s.name);

export function getCitiesForState(stateName: string): string[] {
  const state = INDIA_STATES.find((s) => s.name === stateName);
  return state?.cities ?? [];
}
